module.exports = __webpack_public_path__ + "img/cloth_g2_item_17.231602ef.svg";